import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "product-details-accordion-performance-attributes" }
const _hoisted_2 = { class: "product-details-accordion-performance-attributes__title" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["innerHTML"]


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductDetailsAccordionPerformanceAttributes',
  props: {
    content: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (__props.content.imageUrl)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: __props.content.imageUrl,
            alt: "Performance Attributes",
            class: "product-details-accordion-performance-attributes__title-image"
          }, null, 8, _hoisted_3))
        : _createCommentVNode("", true),
      _createElementVNode("span", null, _toDisplayString(__props.content.title), 1)
    ]),
    _createElementVNode("div", {
      class: "product-details-accordion-performance-attributes__description",
      innerHTML: __props.content.description
    }, null, 8, _hoisted_4)
  ]))
}
}

})